import {
  Flex,
  Box,
  Menu,
  MenuButton,
  Button,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { Icons } from '@texas/components/shared/Icons';
import { useTranslation } from 'react-i18next';

export function SelectedVersionsMenu({
  menuItems,
  selectedRowsCount,
  onClear,
  onSelectAll,
}: {
  menuItems: React.ReactNode | null;
  selectedRowsCount: number;
  onClear: () => void;
  onSelectAll: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Flex justifyContent="space-between" alignItems="baseline" pt={2}>
      <Flex direction="column" align="flex-start">
        <Text variant={selectedRowsCount === 0 ? 'sub' : undefined}>
          {t('general.selectedRows', {
            count: selectedRowsCount,
          })}
        </Text>
        <Flex gap={2}>
          <Button
            size="xs"
            variant="link"
            color="texas.sand.100"
            _light={{ color: 'texas.burntSienna.500' }}
            onClick={onSelectAll}
          >
            {t('general.selectAll')}
          </Button>
          <Button
            size="xs"
            variant="link"
            color="texas.sand.100"
            _light={{ color: 'texas.burntSienna.500' }}
            isDisabled={selectedRowsCount === 0}
            onClick={onClear}
          >
            {t('general.clear')}
          </Button>
        </Flex>
      </Flex>
      <Box>
        <Menu isLazy={true}>
          <MenuButton
            as={Button}
            rightIcon={<Icons.ChevronDown />}
            disabled={selectedRowsCount == 0 || menuItems === null}
          >
            {t('general.actions')}
          </MenuButton>
          {menuItems !== null && <MenuList>{menuItems}</MenuList>}
        </Menu>
      </Box>
    </Flex>
  );
}
